export function getCountryFlagUrl(countryShortName: string, size = '160x120'): string {
  return `https://static-media.meetfrank.com/flags/${size}/${countryShortName.toLowerCase()}.png`;
}
